import { useMemo } from 'react';
import { format, formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { DocumentIndexingItem } from '../../types/documentIndexing';

export type Props = {
  open: boolean;
  item: DocumentIndexingItem | null;
  onClose: () => void;
};

export function useDocumentIndexingErrorModal(props: Props) {
  const item = props.item;

  const formattedNextAttempt = useMemo(() => {
    if (!item?.nextAttemptAt) return null;
    try {
      const date = new Date(item.nextAttemptAt);
      const formatted = format(date, "d MMMM yyyy 'à' HH:mm", { locale: fr });
      const relative = formatDistanceToNow(date, { addSuffix: true, locale: fr });
      return `${formatted} (${relative})`;
    } catch {
      return null;
    }
  }, [item?.nextAttemptAt]);

  const isDriveDisconnected = useMemo(() => {
    if (!item?.error) return false;
    return item.error.toLowerCase().includes('google drive non connecté');
  }, [item?.error]);

  const isMaxAttemptsReached = (item?.attempts ?? 0) >= 5;

  function handleOpenOriginal() {
    if (item?.fileUrl) {
      window.open(item.fileUrl, '_blank', 'noopener,noreferrer');
    }
  }

  return {
    item,
    formattedNextAttempt,
    isDriveDisconnected,
    isMaxAttemptsReached,
    handleOpenOriginal,
  };
}

